<ic-container loadingText="{{ 'labels.resident.fetching' | translate }}" [loading]="loading$ | async">
	<div class="content">
		<ic-fa-icon class="pv-title-decorator" icon="user-circle-o"></ic-fa-icon>
		<div>
			<h1 class="pv-title-main">
				{{ 'general.titles.residents' | translate }} {{ 'dashboard.capacity' | translate: {date: today} }}
			</h1>
			<ic-resident-statistics [statistics]="statistics$ | async"></ic-resident-statistics>
		</div>
	</div>
</ic-container>
